export default "__VITE_ASSET__9f500787__"